export const DEFAULT_PANEL_WIDTH = 360

export const PANEL_TRANSITION_DURATION = 125
